<template>
    <div class="p-integrations">
        <router-view />
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'PIntegrations',
    methods: {
        ...mapMutations([
            'setMyPosition'
        ]),
        setUserPositionFromQuery() {
            this.$route.query['redirect-from'] && this.$route.query.mFrom && this.setMyPosition(this.$route.query.mFrom);
        }
    },
    created() {
        this.setUserPositionFromQuery();
    }
}
</script>

<style lang="scss">
  @import "p-integrations";
</style>